(() => {
  const allowedTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
  const allowedExtension = /\.(jpe?g|png|webp|heic|heif)$/i;
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-film-form]');
    if (!form) return;
    const inputs = [...form.querySelectorAll('[data-photo-input]')];
    const urls = new Map();
    const message = (name) => root.querySelector(`[data-message-${name}]`).textContent;
    function clearPreview(input) {
      const card = input.closest('[data-upload-card]');
      if (urls.has(input)) { URL.revokeObjectURL(urls.get(input)); urls.delete(input); }
      const image = card.querySelector('[data-preview-image]');
      image.hidden = true;
      image.removeAttribute('src');
      card.querySelector('[data-preview]').hidden = true;
      card.querySelector('[data-filename]').textContent = '';
      card.querySelector('[data-remove-photo]').hidden = true;
    }
    function validateFile(input) {
      const file = input.files[0];
      let error = '';
      if (file) {
        if (!allowedExtension.test(file.name) || (file.type && !allowedTypes.has(file.type))) error = message('type');
        else if (file.size > 10 * 1024 * 1024) error = message('size');
      }
      input.setCustomValidity(error);
      input.setAttribute('aria-invalid', error ? 'true' : 'false');
      input.closest('[data-upload-card]').querySelector('[data-file-error]').textContent = error;
      return !error;
    }
    for (const input of inputs) {
      input.addEventListener('change', () => {
        clearPreview(input);
        if (!validateFile(input) || !input.files.length) return;
        const card = input.closest('[data-upload-card]');
        const file = input.files[0];
        card.querySelector('[data-preview]').hidden = false;
        card.querySelector('[data-filename]').textContent = file.name;
        card.querySelector('[data-remove-photo]').hidden = false;
        const image = card.querySelector('[data-preview-image]');
        const url = URL.createObjectURL(file);
        urls.set(input, url);
        image.onerror = () => { image.hidden = true; };
        image.onload = () => { image.hidden = false; };
        image.src = url;
      });
      input.closest('[data-upload-card]').querySelector('[data-remove-photo]').addEventListener('click', () => {
        input.value = '';
        clearPreview(input);
        validateFile(input);
        input.focus();
      });
    }
    const story = form.querySelector('[data-counted]');
    const updateCount = () => { form.querySelector('[data-character-count]').textContent = `${story.value.length} / ${story.maxLength}`; };
    story.addEventListener('input', updateCount);
    updateCount();
    for (const input of form.querySelectorAll('input[type=text],textarea')) {
      input.addEventListener('input', () => input.setCustomValidity(''));
    }
    form.addEventListener('submit', (event) => {
      event.stopPropagation();
      if (form.dataset.submitting) { event.preventDefault(); return; }
      const fileValidity = inputs.map(validateFile).every(Boolean);
      const total = inputs.reduce((sum, input) => sum + (input.files[0]?.size || 0), 0);
      const error = form.querySelector('[data-submit-error]');
      error.hidden = true;
      if (total > 24 * 1024 * 1024) {
        event.preventDefault();
        error.textContent = message('total');
        error.hidden = false;
        error.focus();
        return;
      }
      for (const field of form.querySelectorAll('[required][type=text],textarea[required]')) {
        if (!field.value.trim()) field.value = '';
      }
      if (!fileValidity || !form.reportValidity()) { event.preventDefault(); return; }
      form.dataset.submitting = 'true';
      form.querySelector('[data-submit-button]').disabled = true;
      form.querySelector('[data-button-label]').textContent = message('submitting');
      for (const input of inputs) { if (!input.files.length) input.disabled = true; }
    });
    window.addEventListener('pageshow', () => {
      delete form.dataset.submitting;
      form.querySelector('[data-submit-button]').disabled = !form.querySelector('[name=id]').value;
      form.querySelector('[data-button-label]').textContent = form.dataset.originalLabel;
      for (const input of inputs) input.disabled = false;
    });
    form.dataset.originalLabel = form.querySelector('[data-button-label]').textContent;
  }
  document.querySelectorAll('[data-film-builder]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-film-builder]').forEach(initialize); });
})();
